import { ModelsEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getModels = async (): Promise<any> =>
    APIManager.sendGet(ModelsEnds.GET_MODELS, false, {}, {}, axios);

export const ModelsService = { getModels };
